import script from "./MesRecommandations.vue?vue&type=script&setup=true&lang=js"
export * from "./MesRecommandations.vue?vue&type=script&setup=true&lang=js"

import "./MesRecommandations.vue?vue&type=style&index=0&id=3a699106&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a699106"]])

export default __exports__